import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  defaultButton: {
    textTransform: 'capitalize',
  },
}))

export default useStyles
